module.exports = __webpack_public_path__ + "static/societegenerale-83c507c876bc9142c4761fa8b6743477.png";